var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-avatar',{class:{ 'avatar--border': _vm.url },style:({
    backgroundColor: _vm.colorCompany.bgColor,
    color: _vm.colorCompany.color,
  }),attrs:{"size":_vm.size,"src":_vm.url,"alt":"Avatar de empresa"}},[_c('icon-case',{staticClass:"avatar__icon",style:(`margin-right: 0px; font-size: ${_vm.sizeIcon}`),attrs:{"slot":"icon"},slot:"icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }